import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TransitionContext = createContext();

export const useTransition = () => {
  const context = useContext(TransitionContext);
  if (!context) {
    throw new Error('useTransition must be used within TransitionProvider');
  }
  return context;
};

export const TransitionProvider = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [canRender, setCanRender] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Start transition on route change
    setIsTransitioning(true);
    setCanRender(false);
    window.scrollTo(0, 0);

    // Curtain opens after 1600ms
    const timer = setTimeout(() => {
      setIsTransitioning(false);
      setCanRender(true);
    }, 1600);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <TransitionContext.Provider value={{ isTransitioning, canRender }}>
      {children}
    </TransitionContext.Provider>
  );
};